const balColumns = [
    { field: 'kodp', text: 'kodp', visible: false },
    {
        field: 'enscope_name',
        text: 'enscope_name',
        visible: false,
    },
    { field: 'sname', text: 'Код', width: 100 },
    {
        field: 'name',
        text: 'Наименование',
        width: 250,
    },
    { field: 'kod_separator', text: 'kod_separator', visible: false },
    {
        field: 'kod_ecls',
        text: 'kod_ecls',
        visible: false,
    },
    { field: 'kod_parent', text: 'kod_parent', visible: false },
    {
        field: 'inn',
        text: 'ИНН',
        width: 100,
    },
    { field: 'kpp', text: 'КПП', width: 100 },
    { field: 'addr', text: 'Адрес юридический' },
    {
        field: 'pr_active',
        text: 'pr_active',
        data_type: 'boolean',
        visible: false,
    },
];
export default {
    groups: [
        {
            id: 1,
            label: 'Идентификация',
            collapsed: false,
        },
        {
            id: 2,
            label: 'Технические характеристики',
            collapsed: false,
        },
        {
            id: 3,
            label: 'Месторасположение',
            collapsed: false,
        },
        {
            id: 4,
            label: 'Дополнительные характеристики',
            collapsed: false,
        },
    ],
    components: [
        //group 1
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Идентификатор',
            groupId: 1,
            size: [1, 2],
            fieldNameText: 'eobj_id',
        },
        {
            fieldNameId: 'kindname',
            title: 'Вид энергообъекта',
            fieldType: 'ai-form-select-box',
            fieldNameText: 'kod_srckind',
            validationRules: {
                required: true,
            },
            groupId: 1,
            size: [1, 2],
            extParams: {
                valueExpr: 'kod_srckind',
                displayExpr: 'sname',
                dictionaryRoutePath: 'e-grid./eosrc/dict/srckind/get',
            },
        },
        {
            fieldNameText: 'is_uc',
            title: 'Строящийся',
            fieldType: 'ai-form-check-box',
            groupId: 1,
            size: [1, 2],
        },
        {
            name: 'component-card-dnum',
            title: 'Диспетчерское наименование',
            groupId: 1,
            size: [1, 3],
            fieldNameText: 'dnum',
            validationRules: {
                required: true,
            },
        },
        {
            fieldType: 'ai-form-text-box',
            groupId: 1,
            title: 'Оперативное наименование',
            size: [1, 3],
            fieldNameText: 'sname',
            validationRules: {
                required: true,
            },
        },
        {
            fieldType: 'ai-form-text-box',
            groupId: 1,
            title: 'Полное наименование',
            size: [1, 3],
            fieldNameText: 'fname',
            validationRules: {
                required: true,
            },
        },
        {
            name: 'component-card-seti',
            fieldNameId: 'kodp_seti',
            fieldNameText: 'setiname',
            title: 'Зона филиала',
            validationRules: {
                required: true,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kodp',
                dictionaryRoutePath: 'e-grid./eosrc/dict/seti/get',
            },
            groupId: 1,
            size: [1, 3],
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            groupId: 1,
            title: 'Балансовая принадлежность',
            size: [1, 3],
            fieldNameId: 'bal_id',
            fieldNameText: 'bname', // fieldKey
            validationRules: {
                required: true,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kodp',
                columns: balColumns,
                loadUrl: 'e-grid./bal/data/get',
                keyExpr: 'kodp',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
                additionalFiels: [{ cardFieldName: 'bkod_ecls', dictFieldName: 'kod_ecls' }],
            },
        },
        {
            name: 'component-card-expl-id-vg',
            groupId: 1,
            title: 'Эксплуатационная ответственность',
            size: [1, 3],
            fieldNameId: 'expl_id',
            fieldNameText: 'ename',
            validationRules: {
                required: true,
            },
            extParams: {
                displayExpr: 'name',
                valueExpr: 'kodp',
                gridRoMeta: {
                    keyExpr: 'kodp',
                    columns: [
                        { dataField: 'sname', caption: 'Кратк. наимен.' },
                        {
                            dataField: 'name',
                            caption: 'Наименование',
                        },
                        { dataField: 'parentname', caption: 'Филиал МРСК \\ ФСК \\ ТСК' },
                    ],
                    api: { select: 'e-grid./expl/data/get' },
                },
                gridRoArgs: {
                    select_args: { schema: 'e_grid', table: 'hv_org_res' },
                },
                virtualGridMeta: {
                    columns: balColumns,
                    loadUrl: 'e-grid./bal/data/get',
                    keyExpr: 'kodp',
                    autoLoadData: false,
                    toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
                },
            },
        }, //group 2
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'ВН(/СН/)НН, кВ',
            groupId: 2,
            size: [1, 2],
            fieldNameText: 'vltgs',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Год ввода в эксплуатацию',
            groupId: 2,
            size: [1, 2],
            fieldNameText: 'yearofplugin',
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Год ввода в эксплуатацию после реконструкции',
            groupId: 2,
            size: [1, 2],
            fieldNameText: 'yearofpluginafterreconstr',
        },
        {
            fieldType: 'ai-form-text-box-virtual-grid-dictionary',
            groupId: 3,
            title: 'Адрес',
            size: [1, 4],
            fieldNameId: 'addr_id',
            fieldNameText: 'adr', // fieldKey
            validationRules: {
                required: true,
            },
            extParams: {
                displayExpr: 'kf_adress_o',
                valueExpr: 'kodd',
                columns: [
                    { field: 'kodd', text: 'kodd', visible: false },
                    {
                        field: 'postcode',
                        text: 'Почтовый индекс',
                        width: 100,
                    },
                    { field: 'region', text: 'Субъект федерации', width: 100 },
                    {
                        field: 'district',
                        text: 'Район (адм.)',
                        width: 100,
                    },
                    { field: 'city', text: 'Город (адм.)', width: 100 },
                    {
                        field: 'place',
                        text: 'Населенный пункт',
                        width: 100,
                    },
                    { field: 'street', text: 'Улица', width: 200 },
                    {
                        field: 'house',
                        text: 'Дом (здание, сооружен. и т.д.)',
                        width: 100,
                    },
                    { field: 'flat', text: 'Помещение в пределах дома', width: 50 },
                    {
                        field: 'room',
                        text: 'Комната',
                        width: 50,
                    },
                    { field: 'guid', text: 'GUID ГАР', width: 200 },
                    {
                        field: 'mark_addr',
                        text: 'Краткое написание адреса',
                    },
                    {
                        field: 'district_m',
                        text: 'Муниципальный р-н (округ) \\ Городской округ \\ Внутригородская терр. ГФЗ',
                        visible: false,
                    },
                    {
                        field: 'poselen_m',
                        text: 'Городское(сельское) поселение \\ Межселенная территория \\ Внутригородской р-н Г.О.',
                        visible: false,
                    },
                    { field: 'plan', text: 'Планировочная структура', visible: false },
                    {
                        field: 'kf_adress_o',
                        text: 'kf_adress_o',
                        visible: false,
                    },
                ],
                loadUrl: 'e-grid./address/data/get',
                keyExpr: 'kodd',
                autoLoadData: false,
                toRemoveToolbarItemsNames: ['copy', 'edit', 'add', 'delete', 'save'],
            },
        },
        {
            fieldType: 'ai-form-text-box',
            title: 'Широта',
            groupId: 3,
            size: [1, 1],
            fieldNameText: 'latitude',
        },
        {
            fieldType: 'ai-form-text-box',
            groupId: 3,
            title: 'Долгота',
            size: [1, 1],
            fieldNameText: 'longitude',
        }, //group 4
        {
            fieldType: 'ai-form-text-box-readonly',
            title: 'Идентификатор техн. места',
            groupId: 4,
            size: [1, 6],
            fieldNameText: 'tech_location_code',
        },
        {
            fieldType: 'ai-form-multiline-text-box',
            groupId: 4,
            title: 'Комментарий',
            size: [1, 6],
            fieldNameText: 'coment',
        },
    ],
};
